import React, { Component } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { translate } from "react-i18next"
import CustomReportReviewQuestionParent from "./CustomReportReviewQuestionParent"
import CustomReportReviewQuestionGroup from "./CustomReportReviewQuestionGroup"
import uniqid from "uniqid"

const ExpandIcon = styled.span`
  cursor: pointer;
`

const TitleRow = styled.div`
  margin-right: 0px !important;
  border-bottom: dotted 1px #ccc;
`

class CustomReportFormPageDetails extends Component {
  static propTypes = {
    page: PropTypes.shape({
      nameTranslationIdentifier: PropTypes.string.isRequired,
      formPageId: PropTypes.number.isRequired,
    }).isRequired,
    t: PropTypes.func.isRequired,
    questionSelected: PropTypes.func.isRequired,
    addSelectedQuestions: PropTypes.func,
    removeSelectedQuestions: PropTypes.func
  }

  state = {
    isExpanded: false
  }

  handleClick = () => {
    this.setState(prevState => ({ isExpanded: !prevState.isExpanded }))
  }

  handleCheckboxClick = (e) => {
    if (e.target.value === "false"){
      this.props.page.checked = true

      this.props.addSelectedQuestions(this.props.page.questions)
    } else {
      this.props.page.checked = false

      this.props.removeSelectedQuestions(this.props.page.questions)
    }
  }

  render() {
    const { page, t, questionSelected } = this.props    

    const groupBy = (list, keyGetter) => {
      const map = new Map()
      list.forEach((item) => {
        const key = keyGetter(item)
        const collection = map.get(key)
        if (!collection) {
          map.set(key, [item])
        } else {
          collection.push(item)
        }
      })
      return map
    }

    const getQuestions = (questions) => {
      const groupedQuestions = groupBy(questions, q => q.formPageGroupId)

      const groups = []
      groupedQuestions.forEach((group) => {
        // If all the questions within the group are checked then make sure the group is,
        // if it isn't then make sure its not checked.
        var checked = true
        group.map((question) => {
          if (checked && !question.checked){
            checked = false
          }
        })

        groups.push(
          <CustomReportReviewQuestionGroup
            key={group[0].formPageGroupId}
            groupQuestions={group}
            groupCount={groupedQuestions.size}
            questionSelected={questionSelected}
            addSelectedQuestions={this.props.addSelectedQuestions}
            removeSelectedQuestions={this.props.removeSelectedQuestions}
            checked={checked}
          />
        )
      })

      return groups
    }

    // Creating a unique identitfier for the checkbox to make sure we don't have clashes.
    const checkboxId = `chk_${uniqid()}_${page.formPageId}`

    return (
      <div>
        <TitleRow className="row">
          <div className="col-lg-11 col-md-11">
            <ExpandIcon
                className={this.state.isExpanded ? "fa fa-minus-square-o" : "fa fa-plus-square-o"}
                onClick={this.handleClick}
              >
                &nbsp;
              </ExpandIcon>
              <CustomReportReviewQuestionParent
                pageQuestions={page.questions}
                pageName={t(page.nameTranslationIdentifier)}
              />
          </div>
          <div className="col-lg-1 col-md-1">
          <input
              type="checkbox"
              id={checkboxId}
              checked={page.checked}
              className="filled-in"
              onChange={this.handleCheckboxClick}
              value={page.checked}
            />
            <label htmlFor={checkboxId}>&nbsp;</label>
          </div>
          <br />
        </TitleRow>
        
        {this.state.isExpanded && page.questions.length > 0 ? getQuestions(page.questions) : null}
      </div>
    )
  }
}

export default translate()(CustomReportFormPageDetails)



// WEBPACK FOOTER //
// ./src/components/custom-report/Modals/QuestionSelection/CustomReportFormPageDetails.jsx